/**
 * LearnTipsProvider
 *
 * Single mount point for the Learn Tips feature — renders the persistent
 * toggle button always, and the "?" badge overlay only while the toggle is
 * on. Mount this ONCE near the app root so it sits outside any route's
 * subtree (the overlay scans the whole `document`, so its own position in
 * the React tree doesn't matter — only that it mounts once).
 *
 * NOT wired into `App.tsx` by this change (component builder guardrail) —
 * see the W20 learn-tip sweep report for the exact one-line integration the
 * manager/lead should apply:
 *
 *   function App() {
 *     ...
 *     return (
 *       <ConfirmProvider>
 *         <LearnTipsProvider />
 *         <Shell />
 *       </ConfirmProvider>
 *     );
 *   }
 *
 * Deliberately NOT mounted on the `/review` public ClientReview branch —
 * that's an unauthenticated, external-client audience with its own inline
 * explanatory copy; see the report's "Manager integration needed" section.
 */

import { useLearnTipsStore } from "../../stores/learnTipsStore";
import LearnTipsOverlay from "./LearnTipsOverlay";
import LearnTipsToggle from "./LearnTipsToggle";

export default function LearnTipsProvider() {
  const enabled = useLearnTipsStore((s) => s.enabled);

  return (
    <>
      <LearnTipsToggle />
      {enabled && <LearnTipsOverlay />}
    </>
  );
}
